import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function fetchTutorials() {
    let url = `/CustomerTutorials/GetUserTutorials`;
    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Tutorials found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                //throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Tutorials: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}